import React, { useState } from 'react';
import rightArrowIcon from '../Images/black.png'; // Replace with your actual arrow image path

const Subscribe = () => {

  const [email, setEmail] = useState(''); 
  const [showPopup, setShowPopup] = useState(false); // State to control the popup visibility
  const [popupMessage, setPopupMessage] = useState(''); 

  const handleEmailChange = (event) => {
    setEmail(event.target.value); // Update state when input changes
  };

  const handleSubmit = async () => {
    // Regular expression for validating email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!email) {
      setPopupMessage('Please enter an email address.');
      setShowPopup(true);
    } else if (!emailRegex.test(email)) {
      setPopupMessage('Please enter a valid email address.');
      setShowPopup(true);
    } else {
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/subscription', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email }),
        });
  
        const result = await response.json();
  
        if (response.ok && result.success) {
          // Display success message
          setPopupMessage('Thank you for subscribing!');
          setEmail(''); // Reset the input field after successful submission
        } else {
          // Handle errors from the API
          const errorMessage = result.errors || 'Something went wrong. Please try again later.';
          setPopupMessage(errorMessage);
        }
      } catch (error) {
        console.error('Error subscribing:', error);
        setPopupMessage('An error occurred. Please try again later.');
      }
  
      setShowPopup(true); // Show the popup regardless of success or failure
    }
  };
  

  return (
    <div className="flex justify-center bg-white px-4 sm:px-6 md:px-16 xl:px-0 mb-20 mt-10 max-w-screen-xl mx-auto px-4 xl:px-0 relative">
      <div className="flex flex-col justify-between sm:flex-row rounded-2xl shadow-xl items-center w-full  bg-blue-300 gap-4 md:gap-0 xl:gap-14 py-8 sm:py-14">
        <div className="text-xl sm:text-4xl font-bold px-4 pl-0 md:pl-10 text-center sm:text-left" style={{ fontFamily: 'arial'}}>
          <h2>Subscribe Now</h2>
        </div>
        <div className="flex flex-col justify-between sm:flex-row items-center gap-4 md:gap-14 mr-0 xl:mr-10">
          <div className="flex flex-col items-center sm:items-start space-y-4 w-full ">
            <p className="text-xs">Email</p>
            <input
              type="email"
              value={email} // Bind input value to state
              onChange={handleEmailChange} // Handle input changes
              placeholder="Enter your Email"
              className="w-80 md:w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <hr className="border-t border-gray-400 w-full" />
            <div className="flex flex-row items-start w-full px-2 xl:px-0 ">
              
              <input
                type="checkbox"
                id="consent"
                name="consent"
                className="h-4 w-4 "
              />
              <label htmlFor="consent" className="ml-2 text-xs text-center sm:text-left">
                I want to receive exclusive discounts, latest updates, and industry insights via email.
              </label>
            </div>
          </div>
          
            <button 
            onClick={handleSubmit}
            className="flex items-center px-4 md:px-8  xl:px-12 py-2 sm:py-3 bg-white text-black rounded-full mt-4 sm:mt-6 gap-2 mr-0 md:mr-10 xl:mr-0"
            >
              Submit
              <img src={rightArrowIcon}  alt="Submit" className="ml-2 w-4 sm:w-5 h-auto" />
            </button>
         
        </div>
      </div>
       {/* Popup Modal */}
       {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div 
          className="bg-white p-6 rounded-lg shadow-lg text-center"
          style={{ width: '400px' }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              {popupMessage.includes('Thank you') ? 'Success!' : 'Error'}
            </h2>
            <p className="text-gray-600 mb-6">{popupMessage}</p>
            <button
              onClick={() => setShowPopup(false)}
              className="bg-pink-500 text-white px-6 py-2 rounded-full hover:bg-pink-600"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscribe;
